// src/pages/WayliRawVessels.jsx
import React from "react";
import WayliRawTablePage from "./WayliRawTablePage";

const DEFAULT_COLUMNS = [
  "id",
  "_id",
  "order_customerinvoicecode",
  "tariff_so",
  "cabinet_number",
  "order_status",
  "first_freight_etd",
  "first_freight_eta",
  "old_first_freight_etd",
  "old_first_freight_eta",
  "update_time",
];

export default function WayliRawVessels() {
  return (
    <WayliRawTablePage
      title="raw_vessels"
      endpoint="/api/public/raw-vessels"
      defaultColumnKeys={DEFAULT_COLUMNS}
      selectAllByDefault={false}
    />
  );
}

